import type { FormLabelStyleConfig } from 'components/forms/formLabel/types';

const BASE_STYLE = {
  color: 'feature.secondary',
  fontSize: 'sm',
  fontFamily: 'default',
  fontWeight: 'heavy',
  lineHeight: 'sm',
  h: 3,
  marginEnd: 0.25,
  mb: 0.25,
  textTransform: 'uppercase',
  transition: 'all 0.2s',
} as const;

export const FORM_LABEL_STYLE_CONFIG: FormLabelStyleConfig = {
  baseStyle: BASE_STYLE,
};
